import "./main-shell.scss";

import { useInterceptor } from "@core/services/interceptor.hook";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { ProgressBar } from "primereact/progressbar";
import { Toast } from "primereact/toast";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";

import { appConfig } from "../../../app.config";
import { appFeature } from "../../../app.feature";

export function MainShell() {
  const { progress, toastRef } = useNotificationContext();
  useInterceptor();

  useEffect(() => {
    const faviconUrl = `${appConfig.assetPath}/favicon.ico`;
    const title = `${appFeature.appName}`;

    const link: HTMLLinkElement | null = document.querySelector("#favicon");

    if (link) {
      link.href = faviconUrl;
    }
    if (title) {
      document.title = title || "Bukolabs System";
    }
  }, []);

  return (
    <div id="MainShell" className="main-shell">
      <Toast ref={toastRef} position="bottom-left" />
      {progress?.show && (
        <ProgressBar
          mode="indeterminate"
          style={{
            height: "6px",
            zIndex: 999999,
            position: "fixed",
            width: "100%",
          }}
        ></ProgressBar>
      )}

      <Outlet />
    </div>
  );
}

export default MainShell;
